import React from 'react';
import {
  PASSWORD_STRENGTH_LABEL,
  PASSWORD_STRENGTH_SEGMENTS,
  passwordStrengthFilledSegments,
  passwordStrengthLevel,
  type PasswordStrengthLevel,
} from '../domain/passwordStrength';
import { cn } from '@/lib/utils';

const LEVEL_BAR: Record<PasswordStrengthLevel, string> = {
  fraca: 'bg-error',
  boa: 'bg-warning',
  forte: 'bg-success',
};

const LEVEL_TEXT: Record<PasswordStrengthLevel, string> = {
  fraca: 'text-danger-text',
  boa: 'text-warning-text',
  forte: 'text-success-text',
};

export interface PasswordStrengthMeterProps {
  password: string;
}

/** Three-segment strength meter under the password field (UX only). */
export const PasswordStrengthMeter: React.FC<PasswordStrengthMeterProps> = ({
  password,
}) => {
  if (!password) return null;

  const level = passwordStrengthLevel(password);
  const filled = passwordStrengthFilledSegments(password);

  return (
    <div className="mt-s2 space-y-s2" aria-live="polite">
      <div
        className="flex gap-s1"
        role="meter"
        aria-label="Força da senha"
        aria-valuemin={0}
        aria-valuemax={PASSWORD_STRENGTH_SEGMENTS}
        aria-valuenow={filled}
        aria-valuetext={PASSWORD_STRENGTH_LABEL[level]}
      >
        {Array.from({ length: PASSWORD_STRENGTH_SEGMENTS }, (_, i) => (
          <span
            key={i}
            className={cn(
              'h-1 flex-1 rounded-full bg-surface-2',
              i < filled && LEVEL_BAR[level],
            )}
            aria-hidden
          />
        ))}
      </div>
      <p className={cn('text-xs font-medium', LEVEL_TEXT[level])}>
        {PASSWORD_STRENGTH_LABEL[level]}
      </p>
    </div>
  );
};

export default PasswordStrengthMeter;
